import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { INavigationBackResolveData } from './navigation.data';
import { NavigationService } from './navigation.service';

@Injectable()
export class NavigationBackResolve
  implements Resolve<INavigationBackResolveData> {
  static RESOLVE = {
    // key is the same as the RESOLVE_KEY in navigation.data.ts
    navigationBack: NavigationBackResolve,
  };

  constructor(private _navigationService: NavigationService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<INavigationBackResolveData> {
    const currentUrl = this._navigationService.getCurrentUrl();

    // - prevent set goBackUrl while refreshing the page;
    // - prevent set goBackUrl after a goBack() action, avoid redirect cycles: A -> B -> A -> B;
    const goBackUrl =
      currentUrl !== '/' &&
      currentUrl !== this._navigationService.getLastUrlFromBackAction()
        ? currentUrl
        : null;

    return of({ goBackUrl });
  }
}
